export const AppHeader = ({ }: {}) => {
    return (
        <>
            <div className="flex gap-x-2 items-center justify-center py-2 w-full top-0 z-50 bg-white/80 backdrop-blur-xl border-b border-slate-100 transition-all duration-300">
                <img src="/logo_header.png" alt="logo" className="w-12 lg:w-10 object-contain rounded-lg" />
                {/* <div className="flex flex-col">
                    <h2 className="text-xl lg:text-xl uppercase">Comparateur</h2>
                    <p className="text-lg lg:text-sm font-bold -mt-0.5">Fibre</p>
                </div> */}
            </div>
        </>
    );
};
